<script setup lang="ts">
    import { computed } from 'vue'

    // ---------------- props / emits ----------------

    const props = defineProps<{
        propOpened: boolean
        propSurveyId: number | null
    }>()

    const emit = defineEmits<{
        (e: 'show-access-links', surveyId: number | null): void
        (e: 'start-survey', surveyId: number | null): void
        (e: 'close-dialog'): void
    }>()

    // ---------------- derived ----------------

    const opened = computed(() => props.propOpened)
    const surveyId = computed(() => props.propSurveyId)

    // ---------------- actions ----------------

    function showAccessLinks()
    {
        emit('show-access-links', surveyId.value)
    }

    function startSurvey()
    {
        emit('start-survey', surveyId.value)
    }

    function close()
    {
        emit('close-dialog')
    }
</script>


<template>
    <div class="modal-mask" v-if="opened">
        <div class="modal-wrapper">
            <div class="modal-dialog modal-lg modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Opening a survey</h5>
                        <button type="button" class="close" @click="close">&times;</button>
                    </div>

                    <div class="modal-body">
                        <p class="lead">
                            You're about to open the survey.
                        </p><br />

                        <table class="table">
                            <tbody>
                                <tr>
                                    <td>
                                        <h5>Access links</h5>
                                        <p>These links will let your respondents access the survey with just one click. Why not (re)send them now?​</p>
                                    </td>
                                    <td class="align-middle">
                                        <button class="btn btn-outline-secondary btn-block text-nowrap" @click="showAccessLinks">Access links</button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div class="modal-footer">
                        <button @click="startSurvey" type="button" class="btn btn-primary">Open the survey</button>
                        <button @click="close" type="button" class="btn btn-outline-secondary">Cancel</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>